import { render, staticRenderFns } from "./Saved.vue?vue&type=template&id=4d79d119&scoped=true&"
import script from "./Saved.vue?vue&type=script&lang=js&"
export * from "./Saved.vue?vue&type=script&lang=js&"
import style0 from "./Saved.vue?vue&type=style&index=0&id=4d79d119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79d119",
  null
  
)

export default component.exports